import { cn } from "../utils/tailwind";

export const Gauge = ({
  value,
  max = undefined,
  size = "small",
  showValue = true,
  showPercent = false,
  classNameCircle = "text-[#333]",
  classNameProgress = "text-[hsla(131,41%,46%,1)]",
}: {
  value: number;
  max?: number;
  size: "xxsmall" | "xsmall" | "small" | "base" | "medium" | "large";
  showValue: boolean;
  showPercent?: boolean;
  classNameCircle?: string;
  classNameProgress?: string;
}) => {
  const circumference = 332; //2 * Math.PI * 53; // 2 * pi * radius
  const maxVal = Math.max(value, max ?? 100);
  const valueInCircumference = (value / maxVal) * circumference;
  const strokeDasharray = `${circumference} ${circumference}`;
  const initialOffset = circumference;
  const strokeDashoffset = initialOffset - valueInCircumference;

  const sizes = {
    xxsmall: {
      width: "12",
      height: "12",
      textSize: "text-sm",
    },
    xsmall: {
      width: "16",
      height: "16",
      textSize: "text-xs",
    },
    small: {
      width: "36",
      height: "36",
      textSize: "text-xs",
    },
    base: {
      width: "48",
      height: "48",
      textSize: "text-xs",
    },
    medium: {
      width: "72",
      height: "72",
      textSize: "text-lg",
    },
    large: {
      width: "144",
      height: "144",
      textSize: "text-3xl",
    },
  };

  return (
    <div className="relative flex flex-col items-center justify-center">
      <svg
        fill="none"
        shapeRendering="crispEdges"
        height={sizes[size].height}
        width={sizes[size].width}
        viewBox="0 0 120 120"
        strokeWidth="2"
        className="-rotate-90 transform"
      >
        <circle
          className={classNameCircle}
          strokeWidth="12"
          stroke="currentColor"
          fill="transparent"
          shapeRendering="geometricPrecision"
          r="53"
          cx="60"
          cy="60"
        />
        <circle
          className={cn("animate-gauge_fill", classNameProgress)}
          strokeWidth="12"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={initialOffset}
          shapeRendering="geometricPrecision"
          strokeLinecap="round"
          stroke="currentColor"
          fill="transparent"
          r="53"
          cx="60"
          cy="60"
          style={{
            strokeDashoffset: strokeDashoffset,
            transition: "stroke-dasharray 1s ease 0s,stroke 1s ease 0s",
          }}
        />
      </svg>
      {showValue && size != "xsmall" ? (
        <div className="animate-gauge_fadeIn absolute flex opacity-0">
          <p className={`text-gray-100 ${sizes[size].textSize}`}>
            {showPercent
              ? `${Math.round((value / maxVal) * 100)}%`
              : (value / maxVal) * 100}
          </p>
        </div>
      ) : null}
    </div>
  );
};
